import React from 'react';
import PropTypes from 'prop-types';
import { deepExtract } from 'helpers/deep';
import { transformKeys, transformValues } from 'helpers/object';
import { isObject } from 'helpers/verify';

const CONTEXT_VARIABLE_REGEX = /\{([^{}]*)\}/g;

const normalizeVariable = variable => (variable || '').toUpperCase();
const normalizeKeys = object =>
  transformKeys(normalizeVariable, transformValues(val => (isObject(val) ? normalizeKeys(val) : val), object));

const determineValue = (valueByVariable, match, variable) =>
  deepExtract(normalizeVariable(variable), valueByVariable, match);

const interpolateVariables = (valueByVariable, pattern, text) => {
  const patternToMatch = pattern || CONTEXT_VARIABLE_REGEX;
  return (text || '').replace(patternToMatch, determineValue.bind(null, valueByVariable));
};

const ContextVariables = React.createContext({});

export const DefineVariables = ({ children, variables }) => (
  <ContextVariables.Consumer>
    {contextVariables => (
      <ContextVariables.Provider value={{ ...contextVariables, ...normalizeKeys(variables || {}) }}>
        {children}
      </ContextVariables.Provider>
    )}
  </ContextVariables.Consumer>
);

export const InterpolateVariables = ({ children, pattern }) => (
  <ContextVariables.Consumer>
    {contextVariables => children(interpolateVariables.bind(null, contextVariables, pattern))}
  </ContextVariables.Consumer>
);

DefineVariables.propTypes = {
  children: PropTypes.node.isRequired,
  variables: PropTypes.object,
};

InterpolateVariables.propTypes = {
  children: PropTypes.func.isRequired,
  pattern: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};
